"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var components_1 = require("@lsg/components");

var GridRow_1 = require("@lsg/components/lib/components/atoms/Grid/GridRow");

var GridColumn_1 = require("@lsg/components/lib/components/atoms/Grid/GridColumn");

var FactComponent_1 = require("./FactComponent");

exports.FactsComponent = function (_a) {
  var data = _a.data;

  var _b, _c;

  var factsList = data.array('factsList');
  return React.createElement(components_1.Section, null, React.createElement(components_1.Grid, {
    verticalSpacing: (_b = components_1.Grid.Spacing) === null || _b === void 0 ? void 0 : _b.CONTAINER
  }, React.createElement(GridRow_1.GridRow, {
    gap: (_c = components_1.Grid.Spacing) === null || _c === void 0 ? void 0 : _c.CONTAINER
  }, factsList.map(function (fact, idx) {
    return React.createElement(GridColumn_1.GridColumn, {
      xs: 12,
      sm: 4,
      key: "icon-with-label-" + idx
    }, React.createElement(FactComponent_1.FactComponent, {
      data: fact
    }));
  }))));
};